/**
 * 胎号管理的新增页面 货品配置
 * @author zjs
 * @time 2017-09-18
 */
export default {
     data () {
        return {
            productConfig: [{
                label: "开票单位",
                component: "ElInput",
                prop: "invoice_unit_name"
            },{
                label: "纳税人识别号",
                component: "ElInput",
                prop: "taxpayer_mark"
            },{
                label: "地址、电话",
                component: "ElInput",
                prop: "address_phone"
            }, {
                label: "开户行及帐号",
                component: "ElInput",
                prop: "open_bank_account"
            }]
        }
    }
}